import memoize from "fast-memoize";
const toggleArray = (array = [], value) => {
  const exists = array.includes(value);
  return exists ? array.filter((item) => item !== value) : [...array, value];
};
const isArrayEmpty = (array) => array.length === 0;
const symmetricDifference = (first2, second) => {
  const firstSet = new Set(first2);
  const secondSet = new Set(second);
  return [...first2.filter((element) => !secondSet.has(element)), ...second.filter((element) => !firstSet.has(element))];
};
const areAllElementsPresent = (arrayOne, arrayTwo) => arrayOne.length === arrayTwo.length && arrayOne.every((val) => arrayTwo.includes(val));
const first = (arr) => {
  return arr.length > 0 ? arr[0] : void 0;
};
const isArray = (value) => {
  return Array.isArray(value);
};
const intersect = (array1, array2) => {
  const set1 = new Set(array1);
  const set2 = new Set(array2);
  const intersection = new Set([...set1].filter((element) => set2.has(element)));
  return [...intersection];
};
const toEntities = memoize(
  (data, id, merge) => {
    if (!data)
      return {};
    return data.reduce((accumulator, current) => {
      const key = current[id];
      return {
        ...accumulator,
        [key]: merge ? [...accumulator[key] ?? [], current] : current
      };
    }, {});
  }
);
const filterEntities = memoize((data, keys) => {
  const keysSet = new Set(keys);
  return Object.entries(data).reduce((acc, [key, value]) => {
    if (!keysSet.has(key)) {
      acc[key] = value;
    }
    return acc;
  }, {});
});
const insertIf = (condition, elements) => condition ? [elements] : [];
export {
  areAllElementsPresent,
  filterEntities,
  first,
  insertIf,
  intersect,
  isArray,
  isArrayEmpty,
  symmetricDifference,
  toEntities,
  toggleArray
};
